import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { currentTimeMillis8vwamy6polhm as currentTimeMillis } from '../../../../../../apollo-kotlin-apollo-mpp-utils/com/apollographql/apollo/mpp/utils.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  DefaultHttpInterceptorChain22k3s5gesb9pu as DefaultHttpInterceptorChain,
  dispose2t7a37uqicel0 as dispose,
  HttpInterceptor2khzkwmar9lg6 as HttpInterceptor,
} from './HttpInterceptor.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  get_isGraphQLResponse3ogjhw8yzfes1 as get_isGraphQLResponse,
  get_isMultipart1je26zsopcnca as get_isMultipart,
  multipartBodyFlow272n2l39kgnug as multipartBodyFlow,
} from '../../internal/multipart.mjs';
import {
  flowOf16f7h10nre075 as flowOf,
  flow3tazazxj2t7g4 as flow,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { emitAll2ll41gkd5meqr as emitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { DeferredJsonMerger16i62uujz1qml as DeferredJsonMerger } from '../../internal/DeferredJsonMerger.mjs';
import {
  jsonReader2agwreccj3lmk as jsonReader,
  jsonReaderkr2c3w0efm9b as jsonReader_0,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import {
  toApolloResponse9u5mcqg84l2p as toApolloResponse,
  parseResponse2l74cu4whks78 as parseResponse,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { Token_NULL_getInstance1sp8yn17d7412 as Token_NULL_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReader.mjs';
import { readErrors1y0wtxnlur21l as readErrors } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/internal/ResponseParser.mjs';
import {
  RouterError3i6hxcnqsy5l3 as RouterError,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloException16lek20l78zc3 as ApolloException,
  ApolloHttpException3o30u8ntkffuh as ApolloHttpException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Subscription.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { catchrcnx5mlu3pkp as catch_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import { HttpInfo25xgxbxy3emkc as HttpInfo } from './HttpExecutionContext.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { DefaultHttpRequestComposer3cbqxfvy17yg2 as DefaultHttpRequestComposer } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/DefaultHttpRequestComposer.mjs';
import { DefaultHttpEngine26xguluicr03l as DefaultHttpEngine } from './DefaultHttpEngine.js.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { Key_getInstance30q5r2nw695ls as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, value, $completion) {
  var $this$transform = $this.y67_1;
  var tmp$ret$0 = withHttpInfo($this.z67_1, value, $this.a68_1.e43_1, $this.b68_1, $this.c68_1);
  var tmp = $this$transform.s1d(tmp$ret$0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_collect__dlomyy($this, collector, $completion) {
  var tmp = HttpNetworkTransport$execute$slambda$o$collect$slambda_0(collector, $this.e68_1, $this.f68_1, $this.g68_1, $this.h68_1);
  var tmp_0 = $this.d68_1.b1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var HttpNetworkTransport$execute$slambda$o$collect$slambdaClass;
function HttpNetworkTransport$execute$slambda$o$collect$slambda() {
  if (HttpNetworkTransport$execute$slambda$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
        this.y67_1 = $$this$unsafeFlow;
        this.z67_1 = this$0;
        this.a68_1 = $request;
        this.b68_1 = $httpResponse;
        this.c68_1 = $millisStart;
      }
      b1i(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, value), $completion);
      }
      ud(p1, $completion) {
        return this.b1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$execute$slambda$o$collect$slambdaClass = $;
  }
  return HttpNetworkTransport$execute$slambda$o$collect$slambdaClass;
}
function HttpNetworkTransport$execute$slambda$o$collect$slambda_0($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart) {
  var i = new (HttpNetworkTransport$execute$slambda$o$collect$slambda())($$this$unsafeFlow, this$0, $request, $httpResponse, $millisStart);
  var l = (value, $completion) => i.b1i(value, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$flow, $completion) {
  var millisStart = currentTimeMillis();
  var throwable = null;
  var tmp;
  try {
    var tmp_0 = (new (DefaultHttpInterceptorChain())(plus($this.n68_1.k68_1, $this.n68_1.m68_1), 0)).x67($this.o68_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof Error) {
      var t = $p;
      if (t instanceof CancellationException()) {
        throw t;
      }
      throwable = t;
      tmp_1 = null;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  var httpResponse = tmp;
  var tmp_2;
  if (httpResponse == null) {
    tmp_2 = flowOf(errorResponse($this.n68_1, $this.p68_1.d43_1, ensureNotNull(throwable)));
  } else {
    var tmp_3;
    var containsArg = httpResponse.k49_1;
    if (!(200 <= containsArg ? containsArg <= 299 : false)) {
      tmp_3 = !get_isGraphQLResponse(httpResponse);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = errorResponse_0($this.n68_1, $this.p68_1.d43_1, httpResponse);
    } else {
      if (get_isMultipart(httpResponse)) {
        tmp_2 = multipleResponses($this.n68_1, $this.p68_1.d43_1, $this.q68_1, httpResponse);
      } else {
        tmp_2 = singleResponse($this.n68_1, $this.p68_1.d43_1, $this.q68_1, httpResponse);
      }
    }
  }
  var responses = tmp_2;
  // Inline function 'kotlinx.coroutines.flow.map' call
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  var tmp$ret$2 = new (HttpNetworkTransport$execute$2$$inlined$map$1())(responses, $this.n68_1, $this.p68_1, httpResponse, millisStart);
  var tmp_4 = emitAll($this$flow, tmp$ret$2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
var HttpNetworkTransport$execute$2$$inlined$map$1Class;
function HttpNetworkTransport$execute$2$$inlined$map$1() {
  if (HttpNetworkTransport$execute$2$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, this$0, $request, $httpResponse, $millisStart) {
        this.d68_1 = $this;
        this.e68_1 = this$0;
        this.f68_1 = $request;
        this.g68_1 = $httpResponse;
        this.h68_1 = $millisStart;
      }
      t1d(collector, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_collect__dlomyy.bind(VOID, this, collector), $completion);
      }
      b1d(collector, $completion) {
        return this.t1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$execute$2$$inlined$map$1Class = $;
  }
  return HttpNetworkTransport$execute$2$$inlined$map$1Class;
}
function *_generator_invoke__zhh2q8_1($this, value, $completion) {
  var tmp0 = $this.r68_1;
  $l$block: {
    var tmp;
    var tmp_0 = $this.s68_1;
    if (isInterface(tmp_0, Subscription())) {
      var reader = jsonReader_0(value);
      var payloadResponse = null;
      var errors = null;
      reader.a41();
      while (reader.v1()) {
        switch (reader.c41()) {
          case 'payload':
            if (reader.d40().equals(Token_NULL_getInstance())) {
              reader.c40();
            } else {
              payloadResponse = parseResponse(reader, $this.s68_1, VOID, $this.t68_1, null);
            }

            break;
          case 'errors':
            if (reader.d40().equals(Token_NULL_getInstance())) {
              reader.c40();
            } else {
              errors = readErrors(reader);
            }

            break;
          default:
            reader.c40();
            break;
        }
      }
      reader.b41();
      var tmp_1;
      if (!(errors == null)) {
        tmp_1 = errorResponse($this.u68_1, $this.s68_1, RouterError().r4d(errors));
      } else if (!(payloadResponse == null)) {
        tmp_1 = payloadResponse;
      } else {
        tmp_1 = null;
      }
      tmp = tmp_1;
    } else {
      if ($this.v68_1._v == null) {
        $this.v68_1._v = new (DeferredJsonMerger())();
      }
      var merged = $this.v68_1._v.f66(value);
      var deferredFragmentIds = $this.v68_1._v.c66_1;
      var isLast = !$this.v68_1._v.d66_1;
      var tmp_2;
      if ($this.v68_1._v.e66_1) {
        tmp_2 = null;
      } else {
        tmp_2 = toApolloResponse(jsonReader(merged), $this.s68_1, VOID, $this.t68_1, deferredFragmentIds).q43().i44(isLast).n37();
      }
      tmp = tmp_2;
    }
    var tmp0_elvis_lhs = tmp;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      break $l$block;
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    var transformed = tmp_3;
    var tmp_4 = tmp0.s1d(transformed, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  return Unit_instance;
}
function *_generator_collect__dlomyy_0($this, collector, $completion) {
  var tmp = HttpNetworkTransport$multipleResponses$o$collect$slambda_0(collector, $this.x68_1, $this.y68_1, $this.z68_1, $this.a69_1);
  var tmp_0 = $this.w68_1.b1d(new (sam$kotlinx_coroutines_flow_FlowCollector$0_0())(tmp), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var HttpNetworkTransport$multipleResponses$o$collect$slambdaClass;
function HttpNetworkTransport$multipleResponses$o$collect$slambda() {
  if (HttpNetworkTransport$multipleResponses$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $operation, $customScalarAdapters, this$0, $jsonMerger) {
        this.r68_1 = $$this$unsafeFlow;
        this.s68_1 = $operation;
        this.t68_1 = $customScalarAdapters;
        this.u68_1 = this$0;
        this.v68_1 = $jsonMerger;
      }
      b1i(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, value), $completion);
      }
      ud(p1, $completion) {
        return this.b1i((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$o$collect$slambdaClass = $;
  }
  return HttpNetworkTransport$multipleResponses$o$collect$slambdaClass;
}
function HttpNetworkTransport$multipleResponses$o$collect$slambda_0($$this$unsafeFlow, $operation, $customScalarAdapters, this$0, $jsonMerger) {
  var i = new (HttpNetworkTransport$multipleResponses$o$collect$slambda())($$this$unsafeFlow, $operation, $customScalarAdapters, this$0, $jsonMerger);
  var l = (value, $completion) => i.b1i(value, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$catch, throwable, $completion) {
  var tmp = $this$catch.s1d(Builder().b44($this.b69_1, uuid4()).g44(wrapIfNeeded($this.c69_1, throwable)).n37(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function errorResponse($this, operation, throwable) {
  var tmp;
  if (throwable instanceof ApolloException()) {
    tmp = throwable;
  } else {
    tmp = ApolloNetworkException().o47('Error while reading JSON response', throwable);
  }
  var apolloException = tmp;
  var tmp0_requestUuid = uuid4();
  return Builder().b44(operation, tmp0_requestUuid).g44(apolloException).i44(true).n37();
}
function errorResponse_0($this, operation, httpResponse) {
  var tmp;
  if ($this.l68_1) {
    tmp = httpResponse.o49();
  } else {
    var tmp0_safe_receiver = httpResponse.o49();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.q6();
    }
    tmp = null;
  }
  var maybeBody = tmp;
  var apolloException = ApolloHttpException().l4d(httpResponse.k49_1, httpResponse.l49_1, maybeBody, 'Http request failed with status code `' + httpResponse.k49_1 + '`');
  return flowOf(errorResponse($this, operation, apolloException));
}
function singleResponse($this, operation, customScalarAdapters, httpResponse) {
  var response = toApolloResponse(jsonReader_0(ensureNotNull(httpResponse.o49())), operation, VOID, customScalarAdapters, null);
  return flowOf(response.q43().i44(true).n37());
}
function multipleResponses($this, operation, customScalarAdapters, httpResponse) {
  var jsonMerger = {_v: null};
  // Inline function 'kotlinx.coroutines.flow.mapNotNull' call
  // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
  var this_0 = multipartBodyFlow(httpResponse);
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  var tmp = new (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1())(this_0, operation, customScalarAdapters, $this, jsonMerger);
  return catch_0(tmp, HttpNetworkTransport$multipleResponses$slambda_0(operation, $this));
}
function wrapIfNeeded($this, _this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ApolloException()) {
    tmp = _this__u8e3s4;
  } else {
    tmp = ApolloNetworkException().o47('Error while reading response', _this__u8e3s4);
  }
  return tmp;
}
function withHttpInfo($this, _this__u8e3s4, requestUuid, httpResponse, millisStart) {
  // Inline function 'kotlin.apply' call
  var this_0 = _this__u8e3s4.q43().q42(requestUuid);
  if (!(httpResponse == null)) {
    this_0.c44(new (HttpInfo())(millisStart, currentTimeMillis(), httpResponse.k49_1, httpResponse.l49_1));
  }
  return this_0.n37();
}
var EngineInterceptorClass;
function EngineInterceptor() {
  if (EngineInterceptorClass === VOID) {
    class $ {
      constructor($outer) {
        this.d69_1 = $outer;
      }
      u67(request, chain, $completion) {
        return this.d69_1.j68_1.p67(request, $completion);
      }
    }
    protoOf($).vz = dispose;
    initMetadataForClass($, 'EngineInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    EngineInterceptorClass = $;
  }
  return EngineInterceptorClass;
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.h64_1 = null;
        this.i64_1 = null;
        this.j64_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.k64_1 = ArrayList().u2();
        this.l64_1 = false;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.m64_1 = ArrayList().u2();
      }
      p63(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.i64_1 = serverUrl;
        return this;
      }
      o64(exposeErrorBody) {
        // Inline function 'kotlin.apply' call
        this.l64_1 = exposeErrorBody;
        return this;
      }
      n64(httpEngine) {
        // Inline function 'kotlin.apply' call
        this.j64_1 = httpEngine;
        return this;
      }
      p64(interceptors) {
        // Inline function 'kotlin.apply' call
        this.k64_1.f5();
        this.k64_1.z2(interceptors);
        return this;
      }
      n37() {
        // Inline function 'kotlin.check' call
        if (!(this.h64_1 == null || this.i64_1 == null)) {
          var message = "It is an error to set both 'httpRequestComposer' and 'serverUrl'";
          throw IllegalStateException().o(toString(message));
        }
        var tmp0_elvis_lhs = this.h64_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.i64_1;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = new (DefaultHttpRequestComposer())(tmp1_safe_receiver);
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp2_elvis_lhs = tmp;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          var message_0 = "No HttpRequestComposer found. Use 'httpRequestComposer' or 'serverUrl'";
          throw IllegalStateException().o(toString(message_0));
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var composer = tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.m64_1.s1()) {
          this.k64_1.n2(new (TransportHeadersInterceptor())(this.m64_1));
        }
        var tmp3_elvis_lhs = this.j64_1;
        return new (HttpNetworkTransport())(composer, tmp3_elvis_lhs == null ? DefaultHttpEngine() : tmp3_elvis_lhs, this.k64_1, this.l64_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var TransportHeadersInterceptorClass;
function TransportHeadersInterceptor() {
  if (TransportHeadersInterceptorClass === VOID) {
    class $ {
      constructor(headers) {
        this.e69_1 = headers;
      }
      u67(request, chain, $completion) {
        return chain.x67(request.v49().v48(this.e69_1).n37(), $completion);
      }
    }
    protoOf($).vz = dispose;
    initMetadataForClass($, 'TransportHeadersInterceptor', VOID, VOID, [HttpInterceptor()], [2]);
    TransportHeadersInterceptorClass = $;
  }
  return TransportHeadersInterceptorClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.f69_1 = function_0;
      }
      s1d(value, $completion) {
        return this.f69_1(value, $completion);
      }
      n5() {
        return this.f69_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.n5(), other.n5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.n5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
function sam$kotlinx_coroutines_flow_FlowCollector$0_0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.g69_1 = function_0;
      }
      s1d(value, $completion) {
        return this.g69_1(value, $completion);
      }
      n5() {
        return this.g69_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.n5(), other.n5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.n5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class_0 = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class_0;
}
var HttpNetworkTransport$execute$slambdaClass;
function HttpNetworkTransport$execute$slambda() {
  if (HttpNetworkTransport$execute$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $httpRequest, $request, $customScalarAdapters) {
        this.n68_1 = this$0;
        this.o68_1 = $httpRequest;
        this.p68_1 = $request;
        this.q68_1 = $customScalarAdapters;
      }
      s65($this$flow, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$flow), $completion);
      }
      ud(p1, $completion) {
        return this.s65((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    HttpNetworkTransport$execute$slambdaClass = $;
  }
  return HttpNetworkTransport$execute$slambdaClass;
}
function HttpNetworkTransport$execute$slambda_0(this$0, $httpRequest, $request, $customScalarAdapters) {
  var i = new (HttpNetworkTransport$execute$slambda())(this$0, $httpRequest, $request, $customScalarAdapters);
  var l = ($this$flow, $completion) => i.s65($this$flow, $completion);
  l.$arity = 1;
  return l;
}
var HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
function HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1() {
  if (HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class === VOID) {
    class $ {
      constructor($this, $operation, $customScalarAdapters, this$0, $jsonMerger) {
        this.w68_1 = $this;
        this.x68_1 = $operation;
        this.y68_1 = $customScalarAdapters;
        this.z68_1 = this$0;
        this.a69_1 = $jsonMerger;
      }
      t1d(collector, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_collect__dlomyy_0.bind(VOID, this, collector), $completion);
      }
      b1d(collector, $completion) {
        return this.t1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class = $;
  }
  return HttpNetworkTransport$multipleResponses$$inlined$mapNotNull$1Class;
}
var HttpNetworkTransport$multipleResponses$slambdaClass;
function HttpNetworkTransport$multipleResponses$slambda() {
  if (HttpNetworkTransport$multipleResponses$slambdaClass === VOID) {
    class $ {
      constructor($operation, this$0) {
        this.b69_1 = $operation;
        this.c69_1 = this$0;
      }
      h69($this$catch, throwable, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$catch, throwable), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        return this.h69(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpNetworkTransport$multipleResponses$slambdaClass = $;
  }
  return HttpNetworkTransport$multipleResponses$slambdaClass;
}
function HttpNetworkTransport$multipleResponses$slambda_0($operation, this$0) {
  var i = new (HttpNetworkTransport$multipleResponses$slambda())($operation, this$0);
  var l = ($this$catch, throwable, $completion) => i.h69($this$catch, throwable, $completion);
  l.$arity = 2;
  return l;
}
var HttpNetworkTransportClass;
function HttpNetworkTransport() {
  if (HttpNetworkTransportClass === VOID) {
    class $ {
      constructor(httpRequestComposer, engine, interceptors, exposeErrorBody) {
        this.i68_1 = httpRequestComposer;
        this.j68_1 = engine;
        this.k68_1 = interceptors;
        this.l68_1 = exposeErrorBody;
        this.m68_1 = new (EngineInterceptor())(this);
      }
      j65(request) {
        var customScalarAdapters = ensureNotNull(request.f43_1.m46(Key_getInstance()));
        var httpRequest = this.i68_1.n48(request);
        return this.i69(request, httpRequest, customScalarAdapters);
      }
      i69(request, httpRequest, customScalarAdapters) {
        return flow(HttpNetworkTransport$execute$slambda_0(this, httpRequest, request, customScalarAdapters));
      }
      vz() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.k68_1.u1();
        while (_iterator__ex2g4s.v1()) {
          var element = _iterator__ex2g4s.w1();
          element.vz();
        }
        this.j68_1.q6();
      }
    }
    initMetadataForClass($, 'HttpNetworkTransport');
    HttpNetworkTransportClass = $;
  }
  return HttpNetworkTransportClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Builder_0 as Builder3d75eph7uovs3,
};
//endregion

//# sourceMappingURL=HttpNetworkTransport.mjs.map
